import {
  Control,
  Controller,
  UseFormSetValue,
  useWatch,
} from 'react-hook-form';
import { CreateNoticeSchemaFormValues } from '../schema';
import { Column } from 'components/Layout';
import { styled, Typography } from '@mui/material';
import SwitchRow from './SwitchRow';
import Switch from 'further-ui/components/Switch';

const StyledColumn = styled(Column)(() => ({
  maxWidth: '400px',
}));

type Props = {
  control: Control<CreateNoticeSchemaFormValues>;
  setValue: UseFormSetValue<CreateNoticeSchemaFormValues>;
};

const NotificationPreferences: React.FC<Props> = ({ control, setValue }) => {
  const perInvestorBreakdown = useWatch({
    control,
    name: 'perInvestorBreakdown',
  });

  const notifyInvestorsViaEmail = useWatch({
    control,
    name: 'notificationPreferences.notifyInvestorsViaEmail',
  });

  const updateNotifyByEmail = (value: boolean) => {
    setValue('notificationPreferences.notifyInvestorsViaEmail', value);
    if (!value)
      setValue('notificationPreferences.attachPdfNoticeToEmail', false);
    perInvestorBreakdown.forEach((_, index) => {
      setValue(`perInvestorBreakdown.${index}.notifyViaEmail`, value, {
        shouldDirty: true,
      });
    });
    if (!value) {
      setValue('notificationPreferences.attachPdfNoticeToEmail', false);
    }
  };

  return (
    <StyledColumn spacing="lg">
      <Typography variant="h5">Notification preferences</Typography>
      <SwitchRow text="Notify investors via email">
        <Controller
          control={control}
          name="notificationPreferences.notifyInvestorsViaEmail"
          render={({ field }) => (
            <Switch checked={field.value} onChange={updateNotifyByEmail} />
          )}
        />
      </SwitchRow>
      <SwitchRow
        text="Attach PDF notice to email"
        tooltip="When turned on, a PDF version of the capital call notice will be attached to the email sent to each investor. If turned off, users will receive email notification of the notice but must log into their portal to view the full notice."
      >
        <Controller
          control={control}
          name="notificationPreferences.attachPdfNoticeToEmail"
          render={({ field }) => (
            <Switch
              checked={field.value}
              onChange={field.onChange}
              disabled={!notifyInvestorsViaEmail}
            />
          )}
        />
      </SwitchRow>
      {/* <SwitchRow
        text="Automatically send reminder emails"
        tooltip="You can turn on automatic reminder emails to be sent to investors who have not paid after the notice due date. Reminders are sent on the cadence you select after the notice due date. No reminders are sent before the due date."
      >
       <Controller
          control={control}
          name="notificationPreferences.automaticallySendReminders"
          render={({ field }) => (
            <Switch checked={field.value} onChange={field.onChange} />
          )}
        />
      </SwitchRow> */}
    </StyledColumn>
  );
};

export default NotificationPreferences;
